export default "__VITE_ASSET__DROxY7n0__"